// extracted by mini-css-extract-plugin
export default {"tag":"odVNR","draft":"Y845I","icon":"yz4gx","archived":"qwgI5","published":"yeKxA","text":"phPzj"};